















































import { defineComponent } from '@vue/composition-api'
import AIcon from '@/components/AIcon'
import { mdiLoading } from '@mdi/js'

export default defineComponent({
  name: 'AButton',

  components: { AIcon },

  props: {
    label: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    black: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    ghost: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: false,
      required: false,
    },
    cssClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup(props, ctx) {
    function clickHandler() {
      if (props.loading || props.disabled || props.href) {
        return
      }
      ctx.emit('click')
    }

    return { clickHandler, mdiLoading }
  },
})
